var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapreview"},[_c('baidu-map',{staticClass:"mapre",attrs:{"center":_vm.center,"zoom":_vm.zoom,"scroll-wheel-zoom":true,"ak":_vm.ak},on:{"ready":_vm.handler}},[_c('bm-marker',{attrs:{"position":_vm.center,"dragging":true,"animation":"BMAP_ANIMATION_BOUNCE","icon":{
      url: '../assets/markergif.gif',
      size: { width: 300, height: 157 },
    }}},[_c('bm-label',{attrs:{"content":_vm.labelstr,"labelStyle":{ color: 'gray', fontSize: '16px' },"offset":{ width: -35, height: -30 }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }